import { MustShowProps } from "./types";

export const MustShow = ({ isVisible, children, fallback }: MustShowProps) => {
  if (isVisible) {
    return children;
  }

  if (fallback) {
    return fallback;
  }

  return null;
};
